import actions from './actions';

const initState = {
  entityType: 'table-component',
  visibleColumns:[],
  shouldUpdateColumns:true,
};

export default function tableReducer(state = initState, action) {
  switch (action.type) {
    case actions.ADD_VISIBLE_COLUMNS:
      return {
        ...state,
        visibleColumns: action.columns,
        shouldUpdateColumns: false
      };
      case actions.CLEAR_VISIBLE_COLUMNS:
        return {
          ...state,
          visibleColumns: [],
          shouldUpdateColumns:true
        };
    default:
      return state;
  }
}
